<template>
    <div class="register">
        <form action="" id="res_login">
            <div class="input input1">
                <input type="text" :placeholder="$t('placeholder_tel')" class="u_phone"  v-focus="focusState" name="reg_phone"   autocomplete="off" v-model="user_name">
            </div>
            <div class="input input2">
                <input type="password"   name="reg_password" :placeholder="$t('placeholder_psd')" autocomplete="off"  v-model="user_psw">
            </div>
            <div class="input input3">
                <input type="password"   name="reg_password2" :placeholder="$t('placeholder_psd')" autocomplete="off"   v-model="user_confirm_psw">
            </div>
            <div class="input_verity">
                <div class="input_verity_box verity_box">
                    <input type="text" :placeholder="$t('placeholder_img_verity')" name="verify_code" autocomplete="off"  v-model="user_verify_code">
                </div>
                <div class="check_code_img" id="reg_verify_code">
                    <img :src="registerVerifyCodeImg" alt="" class="verify_code_img" @click="getRegisterVerifyCodeImg()">
                </div>
            </div>
            <div class="input_verity">
                <div class="input_verity_box mes_verity_box">
                    <input type="text" :placeholder="$t('placeholder_verity')" name="reg_code"  id="reg_code" autocomplete="off"   v-model="user_msg_code">
                </div>
                <span class="mes_count_down count_down" @click="getMsgCodeFunc()" v-if="isGetCodeShow">{{$t('get_verity')}}</span>
                <span class="mes_count_down count_down" v-else>{{waitingTime}}(s)</span>
            </div>
         <!--   <div class="other_phone">
                <span @click="forgetPsd()">忘记密码？</span>
            </div>-->
            <button type="button" id="register_login_btn" class="login_btn" @click="registFunc()">{{$t('register')}}</button>
            <a  class="register_btn" @click="getLogin()">{{$t('login')}}</a>
           <!-- <p class="other_login">其他方式登录</p>
            <ul class="login_icons">
                <li><img src="../../assets/images/personalCenter/weixin.png" alt=""></li>
                <li><img src="../../assets/images/personalCenter/QQ.png" alt=""></li>
            </ul>-->
        </form>
    </div>
</template>

<script>
    import { Toast } from 'mint-ui';
    export default {
        name: "register",
        data: function () {
            return {
                registerVerifyCodeImg:"",                                   //注册的图形验证码
                user_name:"",                                               //用户的手机号（用户名）
                user_psw:"",                                                //用户的密码
                user_confirm_psw:"",                                        //用户确认密码
                user_verify_code:"",                                        //图形验证码
                user_msg_code:"",                                           //短信验证码
                isGetCodeShow:true,                                         //默认为true，显示“获取验证码”按钮
                waitingTime:120,                                            //获取短信验证所需要等待的时间，默认是120(s)，单位是s
                stopWaiting:"",                                             //计时器的编号
                regTel:/^1[345789]\d{9}$/,                                   //验证手机号的正则表达式
                focusState: true
            }
        },
        created: function () {
            this.getRegisterVerifyCodeImg();
            this.$store.commit("set_current", '-1');
            this.$store.commit("set_title", 'register');

        },
        directives: {
            focus: {
                inserted(el, {value}) {//inserted只有第一次聚焦
                    //页面渲染时，第一个input框聚焦，
                    // console.log(el, {value});
                    if (value) {
                        el.focus();
                    }
                }
            }
        },
        methods: {
            // 获取注册页面的图形验证码的方法
            getRegisterVerifyCodeImg: function () {
                this.$http({
                    xhrFields: {
                        withCredentials: true
                    },
                    crossDomain: true,
                    method: "post",
                    url: this.weburl + "home/User/verify",
                    dataType:"json",
                    data:{}
                })
                .then( res => {
                    this.registerVerifyCodeImg = res.data;
                })
                .catch( err => {
                    console.log(err);
                })
            },

            // 点击“获取验证码”按钮所触发的方法
            getMsgCodeFunc: function () {
                this.$http({
                    xhrFields: {
                        withCredentials: true
                    },
                    crossDomain: true,
                    method: "post",
                    url: this.weburl + "home/user/checkCode",
                    dataType:"json",
                    data:{
                        verify_code:this.user_verify_code,
                        username:this.user_name,
                        act:'reg'
                    }
                })
                .then( res => {
                    if(res.data.status == 1){
                        this.sendMsgTomobile();
                    }else{
                        this.getRegisterVerifyCodeImg();
                        Toast(res.data.msg);
                    }
                })
                .catch( err => {
                    console.log(err);
                })
            },

            // 倒计时的方法
            countDown: function () {
                this.stopWaiting = setInterval(() => {
                    this.waitingTime -= 1;
                }, 1000);
            },

            // 发送手机验证码的方法
            sendMsgTomobile: function () {
                this.$http({
                    xhrFields: {
                        withCredentials: true
                    },
                    crossDomain: true,
                    method: "post",
                    // url: this.sendMobileMsgWebUrl + "/index.php?m=Home&c=Api&a=send_validate_code&scene=1&type=mobile&mobile="+this.user_name,
                    url: this.weburl + "/index.php?m=Home&c=Api&a=send_validate_code&scene=1&type=mobile&mobile="+this.user_name,
                    dataType:"json",
                    data:{}
                })
                .then( res => {
                    if(res.data.status == 1){
                        this.isGetCodeShow = false;
                        this.countDown();
                        Toast(res.data.msg);
                    }else{
                        Toast(res.data.msg);
                    }
                })
                .catch( err => {
                    console.log(err);
                })
            },
            registFunc: function () {
                if(!this.user_name){
                    Toast("手机号不能为空");
                    return false;
                }
                if(!this.regTel.test(this.user_name)){
                    Toast("手机号格式不正确");
                    return false;
                }
                if(!this.user_psw){
                    Toast("密码不能为空");
                    return false;
                }
                if(this.user_psw.length < 6 || this.user_psw.length > 20){
                    Toast("请输入6~20位的密码");
                    return false;
                }
                if(this.user_psw.length != this.user_confirm_psw.length){
                    Toast("两次密码不一致");
                    return false;
                }
                if(!this.user_verify_code){
                    Toast("图片验证码不能为空");
                    return false;
                }
                if(!this.user_msg_code){
                    Toast("短信验证码不能为空")
                }
                // 发送注册数据
                this.$http({
                    xhrFields: {
                        withCredentials: true
                    },
                    crossDomain: true,
                    method: "post",
                    url: this.weburl + "/home/User/reg",
                    dataType:"json",
                    data:{
                        scene:"1",
                        reg_phone:this.user_name,
                        reg_password:this.user_psw,
                        reg_password2:this.user_confirm_psw,
                        verify_code:this.user_verify_code,
                        reg_code:this.user_msg_code
                    }
                })
                .then( res => {
                    if(res.data.status == 1){
                        Toast(res.data.msg);
                        this.loginSuccess2(res.data.result)
                        // this.$router.back(-2);
                      /*  setTimeout(() => {
                            console.log()
                            this.$router.push({ path: '/login' });
                        }, 1000);*/
                    }else{
                        Toast(res.data.msg);
                        this.getRegisterVerifyCodeImg();
                    }
                })
                .catch( err => {
                    Toast("网络错误，请稍后再试");
                    console.log(err);
                })
            },
            forgetPsd(){
                this.$router.push({path: `/findPassword`});
            },
            getLogin(){
                this.$router.push({path: `/login`});
            },
            loginSuccess2(data) {
                var obj = {};
                obj.nickname = data.nickname;
                obj.mobile = data.mobile;
                obj.head_pic = data.head_pic;
                localStorage.setItem('userInfo', JSON.stringify(obj));
                this.$store.commit("set_userInformation", obj);
                this.$router.go(-2);
                console.log(localStorage['userInfo']);
            },
        },
        computed:{
            weburl: function () {
                return this.$store.state.weburl;
            },
            sendMobileMsgWebUrl: function () {
                return window.location.protocol + "//www.chuanloo.com"
            }
        },
        watch:{
            waitingTime:function (n,o) {
                if(n <= 0){
                    clearInterval(this.stopWaiting);
                    this.waitingTime = 120;
                    this.isGetCodeShow = true;
                }
            }
        }
    }
</script>

<style scoped lang="less">
    @import '../../assets/less/loginCommon.less';
    .register {
        .media;
    }
    .verify_code_img{
        width: 96.19px;
        height: 50px;
    }
    @media (min-width: 768px) and (orientation: portrait){
        .register  {
            width: 375px;
            margin: 47px auto;
            padding: -15px;
            box-shadow: 1px 1px 10px #ccc;
            border-radius: 10px;
        }
    }
</style>
